import React, { useState } from "react";
import Box from '@mui/material/Box';

import { useNavigate, Link, useLocation } from "react-router-dom";

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MenuIcon from '@mui/icons-material/Menu';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';


import Drawer from "@mui/material/Drawer";
// import Button from '@mui/material/Button';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

import { Button, Icon as I } from "semantic-ui-react";


import {

    selectPatientelleGrid,

} from "../../features/patientelle/patientelleSlice";

import { selectisAuthenticated } from "../../features/auth/authSlice";
import { selectCounters, UpdateSpeedDialValue } from "../../features/counter/counterSlice";
import { useSelector, useDispatch } from "react-redux";




function SpeedDialComponent(props) {
    const dispatch = useDispatch();
    let location = useLocation();
    const navigate = useNavigate();

    const [state, setState] = React.useState({
        left: false,
    });
    const PatientelleState = useSelector(selectPatientelleGrid);
    const Auth = useSelector(selectisAuthenticated);
    const coutersStates = useSelector(selectCounters)
    const { SpeedDialValue } = coutersStates

    const { showColumn, hideColumn } = props

    let modifier, mutuelle, supprimer, Paiement, Affichage;

    if (location.pathname === "/") {
        Affichage = <ListItem button>
            <Button icon labelPosition='left' onClick={showColumn} >
                <I name='expand' size='large' />
                {hideColumn === true ? "Affichage Avancé" : "Afffichage Basic"}
            </Button>
        </ListItem>
    } else if (
        location.pathname === "/ActPatientGrid" ||
        location.pathname === "/ActPatientGridHistoric" ||
        location.pathname === "/ActPatientGridDone" ||
        location.pathname === "/ActPatientGridDoneHistoric" ||
        location.pathname === "/ActPatientGridDidntCome" ||
        location.pathname === "/ActPatientGridDidntComeHistoric" ||
        location.pathname === "/PriseEnCharge" ||
        location.pathname === "/PatientelleGridPriseEnCharge" ||
        location.pathname === "/bloc_Main" ||
        location.pathname === "/PatientelleGridBloc" ||
        location.pathname === "/Stock"


    ) {
        Affichage = <ListItem button>
            <Button icon labelPosition='left' onClick={showColumn} >
                <I name='expand' size='large' />
                {hideColumn === true ? "Affichage Avancé" : "Afffichage Basic"}
            </Button>
        </ListItem>
    }

    else {
        Affichage = ""

    }


    modifier = <ListItem button>
        {PatientelleState.nom === undefined ? (
            <Link to="/" className="widthBTN">
                <Button icon labelPosition='left' className="widthBTN" color="blue">
                    <I name='edit' size='large' />
                    Modifier
                </Button>
            </Link>
        ) : PatientelleState.nom === "" ? (
            <Link to="/" className="widthBTN">
                <Button icon labelPosition='left' className="widthBTN" color="blue">
                    <I name='edit' size='large' />
                    Modifier
                </Button>
            </Link>
        ) : (
            <Link to="/UpdatePatientelle" className="widthBTN">
                <Button icon labelPosition='left' className="widthBTN" color="blue">
                    <I name='edit' size='large' />
                    Modifier
                </Button>
            </Link>
        )}
    </ListItem>

    mutuelle = <ListItem button>
        {PatientelleState.nom === undefined ? (
            <Link to="/" className="widthBTN">
                <Button icon labelPosition='left' className="widthBTN" color="purple">
                    <I name='file alternate' size='large' />
                    Mutuelle
                </Button>
            </Link>
        ) : PatientelleState.nom === "" ? (
            <Link to="/" className="widthBTN">
                <Button icon labelPosition='left' className="widthBTN" color="purple">
                    <I name='file alternate' size='large' />
                    Mutuelle
                </Button>
            </Link>
        ) : (
            <Link to="/MutuelleAct" className="widthBTN">
                <Button icon labelPosition='left' className="widthBTN" color="purple">
                    <I name='file alternate' size='large' />
                    Mutuelle
                </Button>
            </Link>
        )}
    </ListItem>

    supprimer = <ListItem button>
        {PatientelleState.nom === undefined ? (
            <Link to="/" className="widthBTN">
                <Button icon labelPosition='left' className="widthBTN" color="red">
                    <I name='user delete' size='large' />
                    Supprimer
                </Button>
            </Link>
        ) : PatientelleState.nom === "" ? (
            <Link to="/" className="widthBTN">
                <Button icon labelPosition='left' className="widthBTN" color="red">
                    <I name='user delete' size='large' />
                    Supprimer
                </Button>
            </Link>
        ) : (
            <Link to="/DeletePatientelle" className="widthBTN">
                <Button icon labelPosition='left' className="widthBTN" color="red">
                    <I name='user delete' size='large' />
                    Supprimer
                </Button>
            </Link>
        )}
    </ListItem>
    Paiement = <ListItem button>
        {PatientelleState.nom === undefined ? (
            <Link to="/" className="widthBTN">
                <Button icon labelPosition='left' className="widthBTN" color="orange">
                    <I name='dollar sign' size='large' />
                    Paiement
                </Button>
            </Link>
        ) : PatientelleState.nom === "" ? (
            <Link to="/" className="widthBTN">
                <Button icon labelPosition='left' className="widthBTN" color="orange">
                    <I name='dollar sign' size='large' />
                    Paiement
                </Button>
            </Link>
        ) : (
            <Link to="/PaymentActAllActs" className="widthBTN">
                <Button icon labelPosition='left' className="widthBTN" color="orange">
                    <I name='dollar sign' size='large' />
                    Paiement
                </Button>
            </Link>
        )}
    </ListItem>


    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const list = (anchor) => (
        <Box
            sx={{ width: "auto" }}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <List>
                {/* <ListItem button>
                    <Link to="/ActPatientGrid" className="widthBTN">
                        <Button icon labelPosition='left' className="widthBTN" color="brown">
                            <I name='wait' size='large' />
                            Salle d'attente
                        </Button>
                    </Link>
                </ListItem> */}
                <ListItem button>
                    <Link to="/ActPatientGridHistoric" className="widthBTN">
                        <Button icon labelPosition='left' className="widthBTN" color="black">
                            <I name='archive' size='large' />
                            Historique
                        </Button>
                    </Link>
                </ListItem>
                <ListItem button>
                    <Link to="/CreatePatientelle" className="widthBTN">
                        <Button icon labelPosition='left' className="widthBTN" color="green">
                            <I name='add user' size='large' />
                            Créer un patient
                        </Button>
                    </Link>
                </ListItem>
                {location.pathname === "/" ? modifier : ""}
                {location.pathname === "/" ? mutuelle : ""}
                {location.pathname === "/" ? supprimer : ""}
                {location.pathname === "/" ? Paiement : ""}


                <ListItem button>
                    <Link to="/PriseEnCharge" className="widthBTN">
                        <Button icon labelPosition='left' className="widthBTN" color="purple">
                            <I name='calendar check' size='large' />
                            Prise en charge
                        </Button>
                    </Link>
                </ListItem>

                {Auth.role === "admin" ? (
                    <ListItem button>
                        <Link to="/AnnualRevenu" className="widthBTN">
                            <Button icon labelPosition='left' className="widthBTN" color="olive">
                                <I name='line graph' size='large' />
                                Statistiques
                            </Button>
                        </Link>
                    </ListItem>
                ) : null}


                {Auth.role === "admin" ? (
                    <ListItem button>
                        <Link to="/bloc_Main" className="widthBTN">
                            <Button icon labelPosition='left' className="widthBTN" color="teal">
                                <I name='heartbeat' size='large' />
                                Bloc
                            </Button>
                        </Link>
                    </ListItem>
                ) : null}

                {Auth.role === "admin" ? (
                    <ListItem button>
                        <Link to="/Stock" className="widthBTN">
                            <Button icon labelPosition='left' className="widthBTN" color="brown">
                                <I name='warehouse' size='large' />
                                Stocks
                            </Button>
                        </Link>
                    </ListItem>
                ) : null}

                {Affichage}
            </List>
        </Box>
    );

    return (

        <>
            <BottomNavigation
                sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 999 }} elevation={3}
                showLabels
                value={SpeedDialValue}
                onChange={(event, newValue) => {
                    dispatch(UpdateSpeedDialValue(newValue));

                }}
            >
                <BottomNavigationAction onClick={() => navigate("/")} label="Patientèle" icon={<PeopleAltIcon fontSize="large" />} />
                <BottomNavigationAction onClick={() => navigate("/ActPatientGrid")} label="Salle d'attente" icon={<AccessTimeIcon fontSize="large" />} />
                <BottomNavigationAction onClick={toggleDrawer("left", true)} label="Menu" icon={<MenuIcon fontSize="large" />} />
            </BottomNavigation>
            <Drawer
                anchor="left"
                open={state["left"]}
                onClose={toggleDrawer("left", false)}
            >
                {list("left")}
            </Drawer>
        </>
    )
}

export default SpeedDialComponent